module.exports = __webpack_public_path__ + "static/frost-giants-town-e73895fa12a6c7ccd2200d99b8de063d.png";